import { useCallback, useEffect, useMemo, useState } from 'react';

import { Box, Button, Container, Stack, SvgIcon, Typography } from '@mui/material';
import { Layout as DashboardLayout } from 'src/layouts/dashboard/layout';
import { CustomersTable } from 'src/sections/customer/customers-table';
import customerService from 'src/services/customerService';


const now = new Date();


const Customer = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [data, setData] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);


  const handleRowsPerPageChange = useCallback(
    (event) => {
      setRowsPerPage(event.target.value);
    },
    []
  );

  useEffect(() => {
    fetchAllCustomers();
  }, [page])

  const fetchAllCustomers = async () => {
    await customerService.allCustomers(page).then((res) => {
      if (res.status == 200) {
        setData(res.data.customers.data);
        setCurrentPage(res.data.customers.current_page);
        setTotalPages(res.data.customers.last_page);
      }
    })
  }


  const handlePageChange = newPage => {
    setPage(newPage);
  };

  return (
    <>
     
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 8
        }}
      >
        <Container maxWidth="xl">
          <Stack spacing={3}>
            <CustomersTable
              items={data}
            // onPageChange={handlePageChange}
            // onRowsPerPageChange={handleRowsPerPageChange}
            // page={page}
            // rowsPerPage={rowsPerPage}
            />
            <div className="mt-4 flex items-center justify-between">
              <p className="text-gray-600">
                Page {currentPage} of {totalPages}
              </p>
              <div className="flex space-x-2">
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  className={`px-4 py-2 rounded-md ${currentPage === 1 ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-blue-500 text-white hover:bg-blue-600'
                    }`}
                >
                  Previous
                </button>
                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className={`px-4 py-2 rounded-md ${currentPage === totalPages ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-blue-500 text-white hover:bg-blue-600'
                    }`}
                >
                  Next
                </button>
              </div>
            </div>
          </Stack>
        </Container>

      </Box>
    </>
  );
};

// Page.getLayout = (page) => (
//   <DashboardLayout>
//     {page}
//   </DashboardLayout>
// );

export default Customer;
